// removed by extract-text-webpack-plugin
module.exports = {"card_info":"cardInfo__card_info__2FH-b","team_name":"cardInfo__team_name__tmUxr","date":"cardInfo__date__3D6uu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/CardInfo/cardInfo.css
// module id = 835
// module chunks = 0